import '@babel/polyfill';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import cssVars from 'css-vars-ponyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import registerServiceWorker from './registerServiceWorker';
import App from './components/App';
import './lib/i18n';
import setLogLevel from './logger';

Sentry.init({
  dsn: 'https://bff11d5e5ffe1de8845761a528666fcc@sentry.akra.network/6',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: false,
  enabled: process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test',
});

setLogLevel();

cssVars();

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
